import { useState } from "react";
import { Link } from "react-router-dom";
import { mangaList, rankings, categories } from "@/mocks/manga";

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState("hanman");

  const currentRanking = rankings[activeTab as keyof typeof rankings] || [];
  const rankedManga = currentRanking
    .map((id) => mangaList.find((m) => m.id === id))
    .filter(Boolean);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            漫画排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时更新，热度排行，追更不迷路</p>
        </div>

        <div className="flex items-center justify-center gap-1 mb-8">
          <div className="inline-flex bg-background-200/70 rounded-full px-1 py-1">
            {categories.map((cat) => (
              <button
                key={cat.key}
                onClick={() => setActiveTab(cat.key)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === cat.key
                    ? "bg-accent-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {rankedManga.map((manga, idx) => {
            if (!manga) return null;
            return (
              <Link
                key={manga.id}
                to={`/article/${manga.id}`}
                className="group flex items-center gap-4 bg-background-50 rounded-xl p-4 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              >
                <div className="relative flex-shrink-0">
                  <span
                    className={`absolute -top-2 -left-2 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-background-50 z-10 ${
                      idx === 0
                        ? "bg-accent-500"
                        : idx === 1
                        ? "bg-primary-500"
                        : idx === 2
                        ? "bg-secondary-500"
                        : "bg-foreground-400"
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <img
                    src={manga.cover}
                    alt={manga.title}
                    className="w-16 h-20 object-cover object-top rounded-lg"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                    {manga.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 truncate">{manga.author}</p>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className="text-xs text-accent-500 font-semibold">{manga.rating}</span>
                    <span className="text-xs text-foreground-400">{manga.status}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}